import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withRouter, Redirect } from 'react-router-dom';

import { Progress, Image } from 'C4';

const Overlay = props => {
  const { id } = props;
  return (
    <div id={`overlay_${id}`} className='overlay'>
      <i id={`lock_${id}`} className='fas fa-lock' />
    </div>
  );
};

class TrainingCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: '',
      loading: true,
    };
  }

  redirect(url, page, path) {
    const { redirPath, history } = this.props;
    if (page === undefined) {
      history.push(`${path !== undefined ? path : redirPath}${url}/0`);
    } else {
      history.push(`${path !== undefined ? path : redirPath}${url}/${page}`);
    }
  }

  render() {
    const {
      appId,
      chapter,
      chapterCount,
      chaptersProgress,
      history,
      index,
      locked,
      lockedSubtitle,
      // lockedSubtitleRedirect,
      redirPath,
      comingSoon,
    } = this.props;

    const { chapterImage, chapterID, chapterTitle } = chapter;

    const { loading, redirect } = this.state;

    let buttonText;
    let redir;
    switch (chaptersProgress.percentage) {
      case 100:
        buttonText = i18n.translate('trainingScreens.restart');
        redir = () => {
          history.push(`/main/training/chapter/${chapterID}/0`);
        };
        break;
      case undefined:
      case 0:
        buttonText = i18n.translate('trainingScreens.start');
        break;
      default:
        buttonText = i18n.translate('trainingScreens.continue');
    }

    if (redirPath.includes('/main/ret/chapter/')) {
      buttonText = i18n.translate('trainingScreens.review');
    }

    if (redir === undefined) {
      redir = path => {
        this.redirect(chapterID, chaptersProgress.last_page, path);
      };
    }

    const title = chapterTitle.split(':');

    return (
      <div className={`trainingCard ${loading ? 'loading' : ''} ${locked ? 'locked' : ''}`}>
        {chapter.badge && chaptersProgress.percentage >= 100 && (
          <a
            href={`https://stack.travpromobile.com/download.php?url=${chapter.badge}`}
            className="badge"
          >
            <FontAwesomeIcon icon={['fas', 'file-certificate']} /> {i18n.translate('reportCard.download')} <br /> Badge
          </a>
        )}
        <div
          role='button'
          tabIndex={index}
          onKeyPress={() => {
            redir();
          }}
          onClick={() => {
            redir();
          }}
        >
          <div className='textContainer'>
            {!loading && (
              <div>
                {comingSoon && <h4>Coming Soon: {chapterTitle}</h4>}
                {!comingSoon && (
                  <React.Fragment>
                    <h3
                      dangerouslySetInnerHTML={{
                        __html: title[0].replace('&', '</br>&'),
                      }}
                    />
                    <span>{title[1]}</span>
                  </React.Fragment>
                )}
                {!locked && (
                  <p className='duration'>
                    <FontAwesomeIcon icon={['far', 'clock']} />
                    {` ${chapterCount} ${i18n.translate(
                      'trainingScreens.durationInMinutes',
                    )}`}
                  </p>
                )}
                {!locked && (
                  <button
                    onClick={e => {
                      e.stopPropagation();
                      redir(redirPath);
                    }}
                  >
                    {buttonText}
                  </button>
                )}
                {lockedSubtitle && locked && (
                  <p>
                    {i18n.translate('trainingScreens.unlock', {
                      number: index + 1,
                    })}
                  </p>
                )}
                {!lockedSubtitle && !comingSoon && locked && (
                  <p>
                    {i18n.translate('trainingScreens.unlock', { number: index })}
                  </p>
                )}
              </div>
            )}
          </div>
          <div className='imageContainer'>
            <Image
              appId={appId}
              load={() => {
                this.setState({ loading: false });
              }}
              src={`https://front.travpromobile.com/${appId}/${chapterImage}`}
              alt={chapterTitle}
              gradient
              staticImage
            />
            {!loading && locked && <Overlay id={index} />}
            {!loading && comingSoon && <Overlay id={index} />}
            {!loading && (
                <span className='chapterNumber'>{`0${index + 1}`.slice(-2)}</span>
              ) && (
                <span className='chapterComplete'>
                  {chaptersProgress.percentage === 100 && !locked && (
                    <FontAwesomeIcon
                      icon={['far', 'check-circle']}
                      className='chapterComplete'
                    />
                  )}
                </span>
              )}
          </div>
          {!locked && !loading && (
            <Progress id={index} value={chaptersProgress.percentage} />
          )}
          {!locked && redirect.length > 0 && <Redirect to={redirect} />}
        </div>
      </div>
    );
  }
}

export default withRouter(TrainingCard);

TrainingCard.propTypes = {
  appId: PropTypes.number.isRequired,
  chapter: PropTypes.shape({
    chapterID: PropTypes.string,
    chapterImage: PropTypes.string,
    chapterImagePro: PropTypes.string,
    chapterItemCount: PropTypes.number,
    chapterNumber: PropTypes.string,
    chapterTitle: PropTypes.string,
  }).isRequired,
  chapterCount: PropTypes.number,
  chaptersProgress: PropTypes.shape({
    chapter: PropTypes.string,
    last_page: PropTypes.number,
    percentage: PropTypes.number,
    progress: PropTypes.number,
    total_pages: PropTypes.number,
  }),
  history: PropTypes.shape().isRequired,
  index: PropTypes.number.isRequired,
  locked: PropTypes.bool,
  comingSoon: PropTypes.bool,
  lockedSubtitle: PropTypes.string,
  // lockedSubtitleRedirect: PropTypes.string,
  redirPath: PropTypes.string,
};

TrainingCard.defaultProps = {
  chapterCount: 0,
  chaptersProgress: {},
  locked: false,
  redirPath: '/main/training/chapter/',
  lockedSubtitle: null,
  comingSoon: false,
  // lockedSubtitleRedirect: '',
};

Overlay.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};
